// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"f0c0cffd","344":"daaab2d9","703":"dff7901f","723":"6ec30445","843":"eece0aac","890":"d480fab0","954":"1b2eabb2"}[chunkId] + ".chunk.js";
};